import { useState } from "react";
import { useMount } from "./useMount";

const broadcastEvent = (event: CustomEvent) => {
  window.postMessage({ type: event.type, ...event.detail }, "*");
  if (window.parent) {
    window.parent.postMessage(
      { type: event.type, ...event.detail, src: window.location.pathname },
      "*"
    );
  }
};

export function useEJXLaunchUrl() {
  const [url, setUrl] = useState(window.location.href);

  useMount(() => {
    window.addEventListener("message", (evt) => {
      if (evt.data.type === "@eyejack/ejx-launcher-button:configure") {
        const { data } = evt;
        if (data.launchUrl !== undefined) {
          setUrl(data.launchUrl);
          // setUrl(data.launchUrl)
        }
      }
    });
    const customEvent = new CustomEvent("@eyejack/ejx-launcher-button:ready", {
      detail: {},
    });
    broadcastEvent(customEvent);
  });
  return url;
}
